import { render, staticRenderFns } from "./tempModal.vue?vue&type=template&id=4e1635e9&"
import script from "./tempModal.vue?vue&type=script&lang=js&"
export * from "./tempModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports